import { observer } from 'mobx-react';
import React from 'react';
import 'reactflow/dist/style.css';
import {
	MessageBar,
	MessageBarType,
	Spinner,
	SpinnerSize,
	Stack,
	StackItem,
} from '@fluentui/react';
import LegalEntityDocument from './LegalEntityDocument';
import OutlookFileDocumentsDlg from './OutlookFileDocumentsDlg';
import OutlookLocationContentsViewerState from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';
import LocationLineItemCtrl from './LocationLineItemCtrl';
import TemplateDocumentsList from '../components/controls/TemplateDocumentsList';
import DragDropTarget from './DragDropTarget';

interface ILegalEntityDocumentsProps {
	state: OutlookLocationContentsViewerState;
	indent: number;
}

class LegalEntityFolder extends React.Component<
	ILegalEntityDocumentsProps,
	{}
> {
	componentDidMount(): void {
		this.props.state.ensureInitialLoaded();
	}

	render() {
		if (this.props.state.loading) return <Spinner size={SpinnerSize.large} />;

		return (
			<>
				<Stack style={{ marginLeft: this.props.indent === 0 ? 0 : 16 }}>
					{this.props.state.error && (
						<MessageBar messageBarType={MessageBarType.error}>
							{this.props.state.error}
						</MessageBar>
					)}

					{this.props.state.documentStates.length === 0 &&
						this.props.state.folderStates.length === 0 &&
						!this.props.state.error && (
							<MessageBar>There are no contents to display.</MessageBar>
						)}

					{this.props.state.folderStates.map((d) => (
						<StackItem>
							{LegalEntityFolder.getFolderComponents(this.props.indent + 1, d)}
						</StackItem>
					))}

					{this.props.state.documentStates.map((d) => (
						<StackItem>
							<LegalEntityDocument key={d.document.webUrl} state={d} />
						</StackItem>
					))}
				</Stack>
			</>
		);
	}


	public static getFolderComponents(indent: number, state: OutlookLocationContentsViewerState) {

		return <>
			<OutlookFileDocumentsDlg state={state.outlookFiling} />
			<TemplateDocumentsList state={state.templates} />
			{this.getLineItem(indent, state)}
		</>;


	}

	private static getLineItem(indent: number, state: OutlookLocationContentsViewerState) {

		let innards = <>
			<LocationLineItemCtrl state={state.lineItem} />
			{/* Render the children, if this folder is expanded */}
			{state.lineItem.isExpanded && (
				<LegalEntityFolder indent={indent} state={state} />
			)}
		</>;

		if (state.isFileable) {
			return <DragDropTarget state={state.dnd}>
				{innards}
			</DragDropTarget>
		} else {
			return innards;
		}
	}
}

export default observer(LegalEntityFolder);
